{
  "$id": "wealthlane://forms/grant-management/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [
    {
      "id": "clearPlanTypeOnPlanChange",
      "watch": "planId",
      "clear": ["planTypeName", "planType", "performanceRuleName", "performanceRuleId", "settlementTypeId", "settlementTypeName"]
    },
    {
      "id": "syncPoolFromPlan",
      "description": "Default pool when user changes Plan Name (legacy grantModal onChange). skipDerivedSync preserves saved poolId on edit hydrate.",
      "watch": "planId",
      "skipDerivedSync": true,
      "set": {
        "poolId": {
          "operator": "optionProp",
          "field": "planId",
          "prop": "poolId"
        }
      }
    },
    {
      "id": "syncPlanTypeLabel",
      "watch": "planTypeName",
      "set": {
        "planType": {
          "operator": "optionProp",
          "field": "planTypeName",
          "prop": "label"
        }
      }
    },
    {
      "id": "syncPerformanceRuleId",
      "watch": "performanceRuleName",
      "set": {
        "performanceRuleId": {
          "operator": "optionProp",
          "field": "performanceRuleName",
          "prop": "value"
        }
      }
    },
    {
      "id": "clearPerformanceRuleWhenNotPsu",
      "watch": "planType",
      "condition": { "field": "planType", "notEquals": "PSU" },
      "clear": ["performanceRuleName", "performanceRuleId"]
    },
    {
      "id": "clearSettlementWhenNotRsuPsu",
      "watch": "planType",
      "condition": {
        "allOf": [
          { "field": "planType", "notEquals": "RSU" },
          { "field": "planType", "notEquals": "PSU" }
        ]
      },
      "clear": ["settlementTypeId", "settlementTypeName"]
    },
    {
      "id": "syncAcceptanceMethodLabel",
      "watch": "acceptanceMethodId",
      "set": {
        "acceptanceMethod": {
          "operator": "optionProp",
          "field": "acceptanceMethodId",
          "prop": "label"
        }
      }
    },
    {
      "id": "syncSettlementTypeLabel",
      "watch": "settlementTypeId",
      "set": {
        "settlementTypeName": {
          "operator": "optionProp",
          "field": "settlementTypeId",
          "prop": "label"
        }
      }
    },
    {
      "id": "clearTermsDocWhenTextEnabled",
      "watch": "enableTermsConditionText",
      "condition": { "field": "enableTermsConditionText", "equals": true },
      "clear": ["termsAndConditionDocumentName"]
    },
    {
      "id": "clearTermsTextWhenDocEnabled",
      "watch": "enableTermsConditionText",
      "condition": { "field": "enableTermsConditionText", "notEquals": true },
      "clear": ["termsAndConditionTextName"]
    }
  ],
  "observers": []
}
